module.exports = {
      id: "Checkmark-green-usage",
      viewBox: "0 0 20 20.604",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Checkmark-green-usage",
      toString: function () {
        return this.url;
      }
    }